import { FronteggContext } from '@frontegg/rest-api';
import { AxiosAmbient } from 'src/lib';
import {
  setSession,
  setSessionStatus,
  setSessionVerifying,
  setCustomerPortalSession,
  setSubscription,
  setSubscriptionLoading,
  setSubscriptionUpdateReviewLoading,
  setSubscriptionUpdateReview,
} from '../slices/payments';
import { showToastSuccess } from '../../../../utilities/toast';
import { showToastError } from '../../../../utilities/errortoast';

export const createCheckoutSession = (plan, quantity, billingCycle) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const data = {
        plan,
        quantity,
        billing_cycle: billingCycle,
      };
      const result = await AxiosAmbient.post(`/checkout/session`, data, {
        headers,
      });
      const response = result?.data;
      dispatch(setSession(response));
    } catch (error) {
      console.error(error);
    }
  };
};

export const verifyCheckoutSession = (stripe_session_id) => {
  return async (dispatch) => {
    dispatch(setSessionVerifying(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await AxiosAmbient.get(
        `/checkout/fulfillment/verify/${stripe_session_id}`,
        { headers }
      );
      if (result?.status === 200) {
        dispatch(setSessionStatus('success'));
      } else {
        dispatch(setSessionStatus('failed'));
      }
    } catch (error) {
      dispatch(setSessionStatus('not_found'));
    } finally {
      dispatch(setSessionVerifying(false));
    }
  };
};

export const createBillingCustomerPortalSession = () => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await AxiosAmbient.post(
        `/billing/customer-portal/session`,
        {},
        { headers }
      );
      if (result?.status === 200) {
        dispatch(setCustomerPortalSession(result?.data));
      } else {
        dispatch(setCustomerPortalSession(null));
      }
    } catch (error) {
      console.error(error);
      dispatch(setCustomerPortalSession(null));
    }
  };
};

export const getSubscription = () => {
  return async (dispatch) => {
    dispatch(setSubscriptionLoading(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await AxiosAmbient.get(`/subscription`, { headers });
      if (result?.status === 200) {
        dispatch(setSubscription(result?.data));
      } else {
        dispatch(setSubscription(null));
      }
    } catch (error) {
      console.error(error);
      dispatch(setSubscription(null));
    } finally {
      dispatch(setSubscriptionLoading(false));
    }
  };
};

export const updateSubscriptionReview = (data) => {
  return async (dispatch) => {
    dispatch(setSubscriptionUpdateReviewLoading(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await AxiosAmbient.post(
        `/subscription/update-review`,
        data,
        { headers }
      );
      if (result?.status === 200) {
        dispatch(setSubscriptionUpdateReview(result?.data));
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setSubscriptionUpdateReviewLoading(false));
    }
  };
};

export const updateSubscription = (data, onSuccess) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await AxiosAmbient.put(`/subscription`, data, { headers });
      if (result?.status === 200) {
        dispatch(getSubscription());
        showToastSuccess('Subscription updated successfully');
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      showToastError('Failed to update subscription');
    }
  };
};
